export const formatTime = (time, addZero = false) => {
    time = new Date(time)
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    let hour = time.getHours()
    let minute = time.getMinutes()
    let second = time.getSeconds()
    return {year, month, day, hour, minute, second}
}